import { ChangeDetectorRef, Component } from '@angular/core';
import { BasePlugin } from '../../base-plugin.component';
import { PluginComponent } from '../../plugin.component';
import { Inspection } from '../../../shared/models/inspection.model';

@Component({
    templateUrl: './training-provided.component.html',
    standalone: false
})
export class InstallationTrainingProvidedPluginComponent extends BasePlugin {
  public trainingProvided: any;
  public config: any;
  public editRoute = ['installation', 'trainingprovided', 'edit'];
  constructor(private cdRef: ChangeDetectorRef) {
    super();
  }

  setConfig(config: any, inspection: Inspection, plugin: any) {
    this.config = config;
    this.initData();
    this.cdRef.detectChanges();
  }

  private initData() {
    this.trainingProvided = this.config.TrainingProvided;
  }
}
PluginComponent.plugins['installationtrainingprovided'] = InstallationTrainingProvidedPluginComponent;
